var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "columns is-multiline" }, [
      _c("div", { staticClass: "column is-narrow" }, [
        _c("div", { staticClass: "box" }, [
          _c(
            "form",
            { attrs: { id: "form-collection-filter" } },
            [
              _c(
                "b-field",
                [
                  _c("b-datepicker", {
                    attrs: {
                      name: "from-date",
                      placeholder: "Click to select...",
                      icon: "calendar-alt",
                      "max-date": _vm.toDate,
                    },
                    model: {
                      value: _vm.fromDate,
                      callback: function ($$v) {
                        _vm.fromDate = $$v
                      },
                      expression: "fromDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-field",
                [
                  _c("b-datepicker", {
                    attrs: {
                      name: "to-date",
                      placeholder: "Click to select...",
                      icon: "calendar-alt",
                      "min-date": _vm.fromDate,
                    },
                    model: {
                      value: _vm.toDate,
                      callback: function ($$v) {
                        _vm.toDate = $$v
                      },
                      expression: "toDate",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "control" }, [
                  _c(
                    "a",
                    {
                      staticClass: "button is-fullwidth is-outlined",
                      class: { "is-loading": _vm.isSubmitting },
                      on: { click: _vm.fetchEndusers },
                    },
                    [
                      _c("b-icon", {
                        attrs: { size: "is-small", icon: "search" },
                      }),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("customer.collections.search"))),
                      ]),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "columns is-multiline" }, [
      _c(
        "div",
        { staticClass: "column is-12" },
        [
          _c(
            "b-field",
            { attrs: { grouped: "" } },
            [
              _c("gridManager", {
                attrs: { "grid-id": _vm.gridId, profiles: _vm.gridProfiles },
                on: {
                  save: _vm.saveProfile,
                  create: _vm.createProfile,
                  update: _vm.updateProfile,
                  select: _vm.selectProfile,
                  delete: _vm.deleteProfile,
                },
              }),
              _c(
                "div",
                { staticClass: "field" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        "icon-left": "globe",
                        type: "is-primary",
                        loading: _vm.isLoadingGlobalExport,
                      },
                      on: { click: _vm.globalExport },
                    },
                    [_vm._v(" Global export ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("ag-grid-vue", {
            staticClass: "ag-theme-alpine",
            staticStyle: { width: "100%", height: "700px" },
            attrs: {
              id: _vm.gridId,
              "row-selection": "multiple",
              "grid-options": _vm.gridOptions,
              pagination: true,
              "pagination-auto-page-size": true,
              "side-bar": ["columns"],
              "row-data": _vm.endusers
                ? _vm.endusers.filter(
                    (e) => e.collections && e.collections.quantity
                  )
                : null,
              "multi-sort-key": "ctrl",
              "get-context-menu-items": _vm.getContextMenuItems,
              modules: _vm.modules,
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }